import { FunctionComponent, ReactNode } from 'react'
import { Alert, AlertTitle, CircularProgress } from '@mui/material'
import { rucksack } from '@black-bear-energy/rucksack'
import { CheckCircleOutlined, ErrorOutline } from '@mui/icons-material'

export const RucksackNotification: FunctionComponent<
  RucksackNotificationProps
> = ({ title, message, severity = 'success', onClose }) => {
  let sx: { bgcolor: string; color: string }
  let icon: ReactNode

  if (severity === 'success') {
    sx = {
      bgcolor: rucksack.palette.Alert.successStandardBg,
      color: rucksack.palette.Alert.successColor,
    }
    icon = <CheckCircleOutlined sx={{ color: rucksack.palette.success.main }} />
  } else if (severity === 'error' || severity === 'warning') {
    sx = {
      bgcolor: rucksack.palette.Alert.errorStandardBg,
      color: rucksack.palette.Alert.errorColor,
    }
    icon = <ErrorOutline sx={{ color: rucksack.palette.error.main }} />
  } else {
    sx = {
      bgcolor: rucksack.palette.Alert.infoStandardBg,
      color: rucksack.palette.Alert.infoColor,
    }
    icon = (
      <CircularProgress size={20} sx={{ color: rucksack.palette.info.main }} />
    )
  }

  return (
    <Alert
      severity={severity}
      variant="outlined"
      icon={icon}
      onClose={onClose}
      sx={{
        display: 'flex',
        width: '320px',
        padding: '6px 16px',
        alignItems: 'flex-start',
        borderRadius: rucksack.shape.borderRadius,
        '& .MuiAlert-message': {
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        },
        '& .MuiAlertTitle-root': {
          marginBottom: 0,
        },
        ...sx,
      }}
    >
      {!!title && <AlertTitle>{title}</AlertTitle>}
      <span style={{ fontWeight: 400, fontSize: '12px' }}>{message}</span>
    </Alert>
  )
}

interface RucksackNotificationProps {
  message: string
  title?: string
  severity?: 'success' | 'info' | 'warning' | 'error'
  onClose?: () => void
}
